// @ts-nocheck
const formatter = new Intl.NumberFormat('en', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    roundingMode: 'halfEven',
});

const convertToOriginalFormat = number => {
    if (number) {
        return formatter.format(number).replace(/,/g, ' ');
    } else if (number === 0) {
        return number;
    }

    return '';
};

export default convertToOriginalFormat;
